import {
  SET_FILTER,
  REMOVE_FILTER,
  REMOVE_ALL_FILTERS,
  SET_FILTERED_RESULTS,
  CLEAR_FILTERED_RESULTS
} from '../actions/projectsFilters.js';

function projectsFilters(state = {active:{}, results:[], projectData:{}}, action) {
  switch (action.type) {
    case SET_FILTER:
      var active = Object.assign({}, state.active);
      active[action.data.type] = action.data;
      return Object.assign({}, state, {active})
    case REMOVE_FILTER:
      var active = Object.assign({}, state.active);
      delete active[action.data.type]
      return Object.assign({}, state, {active})
    case REMOVE_ALL_FILTERS:
      return Object.assign({}, state, {active:{}, results:[], projectData:{}})
    case SET_FILTERED_RESULTS:
      return Object.assign({}, state, {results:[...action.data], projectData:{...(action.projectData || {})}});
    case CLEAR_FILTERED_RESULTS:
      return Object.assign({}, state, {results:[], projectData:{}});
    default:
      return state
  }
}

export default projectsFilters;
